import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ComparisonTypes, ETLReportingSetComparisonTypes, ETLReportingSetDropdownOptions, SingleFieldTypes } from "../../../../cxone-etl-reporting-set.model";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";

@Component({
    selector: "cv-comparison-field",
    templateUrl: "./comparison-field.component.html",
    styleUrls: ["./comparison-field.component.scss"],
})
export class ComparisonFieldComponent implements OnInit {
    @Output() addBtnClick = new EventEmitter();
    @Output() editInputClick = new EventEmitter();
    @Output() formChanged = new EventEmitter();

    @Input() comparisonForm: any;
    public comparisonOptions: ETLReportingSetDropdownOptions[] = [];
    comparisonTypes = ComparisonTypes;
    singleFieldTypes = SingleFieldTypes;

    constructor(private cvLocalizationService: CVLocalizationService) { }

    async ngOnInit() {
        await this.loadLocalization();
        this.initializeComparisonOptions();
    }

    public initializeComparisonOptions(): void {
        this.comparisonOptions = [
            {
                id: ETLReportingSetComparisonTypes.GreaterThan,
                label: this.getLocalizationString(
                    "Greater_Than",
                    "GreaterThan"
                ),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.GreaterThan]
            },
            {
                id: ETLReportingSetComparisonTypes.GreaterThanOrEqualTo,
                label: this.getLocalizationString(
                    "Greater_Than_Or_Equal_To",
                    "GreaterThanOrEqualTo"
                ),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.GreaterThanOrEqualTo]
            },
            {
                id: ETLReportingSetComparisonTypes.LessThan,
                label: this.getLocalizationString("Less_Than", "LessThan"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.LessThan]
            },
            {
                id: ETLReportingSetComparisonTypes.LessThanOrEqualTo,
                label: this.getLocalizationString(
                    "Less_Than_Or_Equal_To",
                    "LessThanOrEqualTo"
                ),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.LessThanOrEqualTo]
            },
            {
                id: ETLReportingSetComparisonTypes.EqualTo,
                label: this.getLocalizationString("Equal_To", "EqualTo"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.EqualTo]
            },
            {
                id: ETLReportingSetComparisonTypes.IsNull,
                label: this.getLocalizationString("Is_Null", "IsNull"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.IsNull]
            },
            {
                id: ETLReportingSetComparisonTypes.IsNotNull,
                label: this.getLocalizationString("Is_Not_Null", "IsNotNull"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.IsNotNull]
            },
            {
                id: ETLReportingSetComparisonTypes.IsNullOrEmpty,
                label: this.getLocalizationString(
                    "Is_Null_Or_Empty",
                    "IsNullOrEmpty"
                ),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.IsNullOrEmpty]
            },
            {
                id: ETLReportingSetComparisonTypes.IsNotNullAndIsNotEmpty,
                label: this.getLocalizationString(
                    "Is_Not_Null_And_Is_Not_Empty",
                    "IsNotNullAndIsNotEmpty"
                ),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.IsNotNullAndIsNotEmpty]
            },
            {
                id: ETLReportingSetComparisonTypes.IsTrue,
                label: this.getLocalizationString("Is_True", "IsTrue"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.IsTrue]
            },
            {
                id: ETLReportingSetComparisonTypes.IsFalse,
                label: this.getLocalizationString("Is_False", "IsFalse"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.IsFalse]
            },
            {
                id: ETLReportingSetComparisonTypes.NotEqualTo,
                label: this.getLocalizationString("Not_Equal_To", "NotEqualTo"),
                value: this.comparisonTypes[ETLReportingSetComparisonTypes.NotEqualTo]
            },
        ];
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "ETL_Reporting_Set",
            key,
            defaultValue
        );
        return baseString;
    }

    fieldAddClick(fieldName) {
        this.addBtnClick.emit(fieldName);
    }

    editInput(item) {
        this.editInputClick.emit(item);
    }

    comparisonTypeChange() {
        if (this.singleFieldTypes.includes(this.comparisonForm.comparisonType.value)) {
            this.comparisonForm.field2 = [];
        }
        this.formChanged.emit(this.comparisonForm);
    }
}
